import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, fileUrl } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { Loading, EmptyState } from "@/components/kit";
import { Gift } from "lucide-react";

export default function Rewards() {
  const { user } = useAuth();
  const [rewards, setRewards] = useState(null);
  const [points, setPoints] = useState(0);
  const [redemptions, setRedemptions] = useState([]);
  const [busy, setBusy] = useState("");

  const load = useCallback(async () => {
    const [r, m, red] = await Promise.all([
      api.getRewards().catch(() => []),
      api.getMember(user.member_id).catch(() => ({ points: 0 })),
      api.getRedemptions(user.member_id).catch(() => []),
    ]);
    setRewards(r); setPoints(m.points || 0); setRedemptions(red);
  }, [user.member_id]);
  useEffect(() => { load(); }, [load]);

  const redeem = async (r) => {
    if (points < r.points_cost) return toast.error("Poin tidak cukup");
    if (!window.confirm(`Tukar ${r.points_cost} poin untuk "${r.title}"?`)) return;
    setBusy(r.id);
    try { await api.redeem(r.id, user.member_id); toast.success("Reward ditukar!"); load(); }
    catch (e) { toast.error(e.message); } finally { setBusy(""); }
  };

  return (
    <div className="space-y-5 fade-in">
      <div className="flex items-end justify-between">
        <div>
          <div className="hsc-label">Loyalty</div>
          <h1 className="font-display text-3xl text-white">Rewards</h1>
        </div>
        <div className="text-right">
          <div className="hsc-label">Poin</div>
          <div className="font-display text-2xl text-[#E7C25B]">{points}</div>
        </div>
      </div>

      {rewards === null ? <Loading /> : !rewards.length ? <EmptyState icon={Gift} title="Belum ada reward" /> : (
        <div className="space-y-3">
          {rewards.map((r) => {
            const can = points >= r.points_cost;
            return (
              <div key={r.id} className="flex items-center gap-4 rounded-2xl border border-[#1F1F22] bg-[#0A0A0C] p-3" data-testid="reward-card">
                {r.image_path ? <img src={fileUrl(r.image_path)} alt={r.title} className="h-16 w-16 rounded-xl object-cover" /> : <div className="flex h-16 w-16 items-center justify-center rounded-xl bg-[#141416]"><Gift className="h-6 w-6 text-[#5A5A5F]" /></div>}
                <div className="flex-1">
                  <div className="text-white">{r.title}</div>
                  <div className="text-sm text-[#E7C25B]">{r.points_cost} poin</div>
                </div>
                <button disabled={!can || busy === r.id} onClick={() => redeem(r)} data-testid="redeem-btn"
                  className={`rounded-full px-4 py-2 text-[12px] font-semibold ${can ? "bg-white text-black" : "border border-[#1F1F22] text-[#5A5A5F]"}`}>
                  {can ? "Tukar" : "Kurang"}
                </button>
              </div>
            );
          })}
        </div>
      )}

      {!!redemptions.length && (
        <div>
          <div className="hsc-label mb-2 mt-4">Riwayat Penukaran</div>
          <div className="space-y-2">
            {redemptions.map((rd, i) => (
              <div key={i} className="flex items-center justify-between rounded-lg border border-[#141416] px-3 py-2 text-sm">
                <span className="text-white">{rd.title}</span>
                <span className="text-[11px] text-[#6E6E73]">{formatDate(rd.redeemed_at)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
